var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilterIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 148.45 131.96",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12,20.62H21.2a16.42,16.42,0,0,0,31.82,0h91.31a4.13,4.13,0,0,0,0-8.25H53a16.42,16.42,0,0,0-31.82,0H4.12a4.13,4.13,0,0,0,0,8.25Zm33-12.37a8.25,8.25,0,1,1-8.24,8.24A8.26,8.26,0,0,1,37.11,8.25ZM144.33,61.86H119a16.41,16.41,0,0,0-31.82,0H4.12a4.12,4.12,0,1,0,0,8.24H87.18a16.42,16.42,0,0,0,31.82,0h25.33a4.12,4.12,0,0,0,0-8.24ZM103.09,74.23A8.25,8.25,0,1,1,111.34,66,8.26,8.26,0,0,1,103.09,74.23Zm41.24,37.11H65.39a16.41,16.41,0,0,0-31.81,0H4.12a4.13,4.13,0,0,0,0,8.25H33.58a16.41,16.41,0,0,0,31.81,0h78.94a4.13,4.13,0,0,0,0-8.25ZM49.48,123.71a8.25,8.25,0,1,1,8.25-8.25A8.26,8.26,0,0,1,49.48,123.71Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter-icon.7f1a6f1f.svg";
export { ForwardRef as ReactComponent };